import { useEffect, useState } from "react";
import styled from "styled-components";

const InboxWrapper = styled.div`
  max-width: 900px;
  margin: 30px auto;
  background: white;
  box-shadow: 0 4px 8px rgba(0,0,0,0.1);
  border-radius: 8px;
  padding: 20px;
`;

const MessageBox = styled.div`
  border-bottom: 1px solid #ddd;
  padding: 15px;
  background: ${(props) => (props.read ? "white" : "#f2f9ff")};
  &:hover {
    background: #f9f9f9;
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 10px;
  button {
    padding: 5px 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
  }
  .delete {
    background: #e74c3c;
    color: white;
  }
  .reply {
    background: #3498db;
    color: white;
  }
`;

export const AdminInbox = () => {
  const [messages, setMessages] = useState([]);
  const [replyTo, setReplyTo] = useState(null);
  const [replyText, setReplyText] = useState("");

  const fetchMessages = async () => {
    const res = await fetch("https://api.pth-hokej.pl/api/messages");
    const data = await res.json();
    setMessages(data);
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  const markAsRead = async (id) => {
    await fetch(`https://api.pth-hokej.pl/api/messages/${id}/read`, { method: "PATCH" });
    fetchMessages();
  };

  const deleteMessage = async (id) => {
    await fetch(`https://api.pth-hokej.pl/api/messages/${id}`, { method: "DELETE" });
    fetchMessages();
  };

  const sendReply = async (id) => {
    await fetch(`https://api.pth-hokej.pl/api/messages/${id}/reply`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ replyText }),
    });
    setReplyTo(null);
    setReplyText("");
    alert("Odpowiedź wysłana!");
  };

  return (
    <InboxWrapper>
      <h2>Skrzynka odbiorcza</h2>
      {messages.map((msg) => (
        <MessageBox key={msg._id} read={msg.read}>
          <b>{msg.title}</b> od: <i>{msg.email}</i>
          <p>{msg.content}</p>
          <small>{new Date(msg.createdAt).toLocaleString()}</small>
          <Actions>
            {!msg.read && (
              <button onClick={() => markAsRead(msg._id)}>Oznacz jako przeczytane</button>
            )}
            <button className="delete" onClick={() => deleteMessage(msg._id)}>
              Usuń
            </button>
            <button className="reply" onClick={() => setReplyTo(msg._id)}>
              Odpowiedz
            </button>
          </Actions>

          {replyTo === msg._id && (
            <div style={{ marginTop: "10px" }}>
              <textarea
                style={{ width: "100%", minHeight: "80px" }}
                value={replyText}
                onChange={(e) => setReplyText(e.target.value)}
              />
              <button
                style={{ marginTop: "5px", padding: "5px 10px", background: "#2ecc71", color: "white" }}
                onClick={() => sendReply(msg._id)}
              >
                Wyślij odpowiedź
              </button>
            </div>
          )}
        </MessageBox>
      ))}
    </InboxWrapper>
  );
};
